module.exports = __webpack_public_path__ + "img/type-5.74d0b6eb.png";